import store from "@/store/store";
import {
  VuexModule,
  Module,
  Mutation,
  getModule
} from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "mask",
  store
})
class MaskModule extends VuexModule {
  /* state */
  maskActive = false;
  maskInnerHtml = "";
  afterClosed = () => {
    // do nothing
  };

  /* getter */

  /* mutation */
  @Mutation
  alertMask (maskInner: string) {
    this.maskInnerHtml = maskInner;
    this.maskActive = true;
  }

  @Mutation
  closeMask (noCallBack?: boolean) {
    this.maskActive = false;
    if (!noCallBack) {
      if (this.afterClosed) {
        this.afterClosed();
      }
      this.afterClosed = () => { /* do something */ };
    }
  }

  @Mutation
  afterClosedEvent (handEven: () => void) {
    this.afterClosed = handEven;
  }
}

export default getModule(MaskModule);
